import {addYears} from "date-fns";

const currentDate: Date = new Date();
const minBirthDate: Date = addYears(currentDate, -72);
const minPassportDate: Date = addYears(currentDate, -27);
const minForeignPassportDate: Date = addYears(currentDate, -5);
const maxForeignPassportDate: Date = addYears(currentDate, 15);

export {currentDate, minBirthDate, minPassportDate, minForeignPassportDate, maxForeignPassportDate}